const c="0x82ad56cb";export{c as aggregate3Signature};
